/**
 * Composable para manejar el título de la página
 * Formato: "<nombre página> - {appName}"
 * El appName se obtiene del store de configuración (cargado desde /configs)
 */
export const usePageTitle = () => {
  const route = useRoute()
  const configStore = useConfigStore()
  const authStore = useAuthStore()

  // Solo cargar la configuración si el usuario está autenticado y no está cargada
  if (authStore.isAuthenticated && !configStore.loaded) {
    configStore.loadConfig().catch(() => {
      // Silenciar error, se usará el fallback
    })
  }

  // Obtener el título de la página desde definePageMeta o i18n
  const pageTitle = computed(() => {
    // Primero intentar obtener desde route.meta.title
    if (route.meta.title) {
      return route.meta.title
    }

    // Si no hay título en meta, intentar generar desde el nombre de la ruta
    return null
  })

  // Nombre de la app desde el store
  const appName = computed(() => configStore.appName)

  // Título completo para el navegador
  const fullTitle = computed(() => {
    if (pageTitle.value) {
      return `${pageTitle.value} - ${appName.value}`
    }
    return appName.value
  })

  // Establecer el título del navegador
  useHead({
    title: fullTitle
  })

  return {
    pageTitle,
    fullTitle,
    appName
  }
}
